import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionService } from './session.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HttpService {
  protected language: number = 1;
  constructor(
    protected http: HttpClient,
    protected session: SessionService,
  ) {
    // this.language = this.languageService.CurrentLang.IsLeft ? 2 : 1;
  }

  doGet(url: string, options?: any): Observable<any> {
    // console.log(this.session.ApiUrl + url);
    return this.http.get(this.session.ApiUrl + url, options);
  }

  doPost(url: string, body: any, options?: any) {
    return this.http.post(this.session.ApiUrl + url, body, options);
  }

  download(url: string, options: any) {
    options.responseType = 'blob';

    return this.http.get(this.session.ApiUrl + url, options);
  }

  downloadPostRequest(url: string, body: any, options?: any) {
    options.responseType = 'blob';
    return this.http.post(this.session.ApiUrl + url, body, options);
  }

  sendBeacon(url: string, data: any) {
    navigator.sendBeacon(url, data);
  }
}
